import axios from "axios";

const DEFAULT_API_URL = "https://api.osfatun.com.ar";

export async function fetchBenefitCatalog(type) {
  const baseUrl = (process.env.VUE_APP_ROOT_API || DEFAULT_API_URL).replace(/\/+$/, "");
  const rows = [];
  let page = 1;
  let lastPage = 1;
  do {
    const response = await axios.get(`${baseUrl}/api/public/benefit-catalogs/${type}`, { params: { page, per_page: 5000 } });
    rows.push(...response.data.data);
    lastPage = response.data.last_page;
    page += 1;
  } while (page <= lastPage);
  return rows;
}
